const state = {
    Items: {
        data: [],
        total: 0,
        pages: {
            page: 1,
            totalPage: 1,
            limit: 25,
            filter: {}
        },
    },
    Loadings: {
        list: false,
        detail: false,
    },
    Item: null,
    Requestors: {},
    FaulTypes: {},
};

const getters = {
    Items: (state) => state.Items,
    Loadings: (state) => state.Loadings,
    Item: (state) => state.Item,
};

const actions = {
    async getList({ commit }, params) {
        commit('setLoadings', { key: "list", val: true });
        return new Promise((resolve, reject) => {
            global.axios.get(`api/cases`, { params: params })
                .then(response => {
                    commit('setLoadings', { key: "list", val: false });
                    response.data.data.pages = params
                    commit('setListItems', response.data.data);
                    resolve(response);
                })
                .catch(error => reject(error));
        });
    },
    async deteleItem({ commit }, params) {
        return new Promise((resolve, reject) => {
            global.axios.delete(`/api/cases`, {
                    data: {
                        ids: params
                    }
                })
                .then(response => {
                    resolve(response);
                })
                .catch(error => reject(error));
        });
    },

    async getSimilarCase({ commit }, params) {
        commit('setLoadings', { key: "list", val: true });
        return new Promise((resolve, reject) => {
            global.axios.get(`api/cases`, { params: params })
                .then(response => {
                    commit('setLoadings', { key: "list", val: false });
                    response.data.data.pages = params
                    commit('setSimilarCase', response.data.data);
                    resolve(response);
                })
                .catch(error => reject(error));
        });
    },
    async getSimilarCaseNLT({ commit }, params) {
        commit('setLoadings', { key: "list", val: true });
        return new Promise((resolve, reject) => {
            global.axios.get(`api/cases/similar-nlt`, { params: params })
                .then(response => {
                    commit('setLoadings', { key: "list", val: false });
                    response.data.data.pages = params
                    commit('setSimilarCase', response.data.data);
                    resolve(response);
                })
                .catch(error => reject(error));
        });
    },

    async getCase({ commit }, params) {
        return new Promise((resolve, reject) => {
            global.axios.get(`api/cases/${params.case_id}`)
                .then(response => {
                    response.data.data.pages = params
                    commit('setItem', response.data.data);
                    resolve(response);
                })
                .catch(error => reject(error));
        });
    },

    async getSelectRequestors({ commit }, params) {

        return new Promise((resolve, reject) => {
            global.axios.get(`api/requestor`, { params: params })
                .then(response => {
                    response.data.data.pages = params
                    commit('setSelectRequestors', response.data.data);
                    resolve(response);
                })
                .catch(error => reject(error));
        });
    },

    async getFaultTypes({ commit }, params) {

        return new Promise((resolve, reject) => {
            global.axios.get(`api/references`, { params: params })
                .then(response => {
                    response.data.data.pages = params
                    commit('setFaultTypes', response.data.data);
                    resolve(response);
                })
                .catch(error => reject(error));
        });
    },


    async raiseCase({ commit }, params) {
        if (params.id) {
            return new Promise((resolve, reject) => {
                global.axios.put(`api/cases/${params.id}`, params)
                    .then(response => {
                        response.data.data.pages = params
                        commit('setTotalListItems', 0);
                        resolve(response);
                    })
                    .catch(error => reject(error));
            });
        } else {
            return new Promise((resolve, reject) => {
                global.axios.post(`api/cases`, params)
                    .then(response => {
                        response.data.data.pages = params
                        commit('setTotalListItems', 0);
                        resolve(response);
                    })
                    .catch(error => reject(error));
            });
        }
    },

    async exportCsv({ commit }, params) {
        return new Promise((resolve, reject) => {
            global.axios.get(`api/cases/export`, {
                    params: params,
                    responseType: 'blob'
                })
                .then(response => {
                    resolve(response);
                })
                .catch(error => reject(error));
        });
    },

    async updateRemarksCase({ commit }, params) {
        return new Promise((resolve, reject) => {
            let formData = new FormData();
            for (var i = 0; i < params.action.photos.length; i++) {
                let photo = params.action.photos[i];
                formData.append('photos[' + i + ']', photo);
            }
            if (params.data.description == null)
                params.data.description = '';
            formData.append('description', params.data.description);
            formData.append('remark_type', params.data.remark_type);
            global.axios(`/api/cases/remarks/${params.case_id}`, {
                    method: "POST",
                    data: formData,
                    headers: {
                        Accept: "application/json",
                    },
                })
                .then(response => {
                    let data = {};
                    if (params.data.remark_type == 'CaseActionTaken') {
                        data.job_action_taken_id = response.data.data.action_taken.id;
                        data.action_taken = response.data.data.action_taken;
                    } else {
                        data.job_work_finding_id = response.data.data.work_finding.id;
                        data.work_finding = response.data.data.work_finding;
                    }
                    commit('updateRemarkCase', data)
                    resolve(response);

                })
                .catch(error => reject(error));
        });
    },

    async deleteAttachments({ commit }, params) {
        return new Promise((resolve, reject) => {

            global.axios(`/api/attachments`, {
                    method: "DELETE",
                    data: { ids: params.ids },
                    headers: {
                        Accept: "application/json",
                    },
                })
                .then(response => {
                    commit('deleteAttachments', params);
                    resolve(response);
                })
                .catch(error => reject(error));
        });
    },
    async getCountCase({ commit }, params) {
        return new Promise((resolve, reject) => {
            global.axios.get(`api/cases/count`, { params: params })
                .then(response => {
                    resolve(response.data.data);
                })
                .catch(error => reject(error));
        });
    },
    // Get custom fields
    async getCaseSettingCustomFields({ commit }, params) {
        return new Promise((resolve, reject) => {
            global.axios.get(`api/case-settings/custom-field`, { params: params })
            .then(response => {
                resolve(response);
            }).catch(error => reject(error));
        });
    },
    // Get Case Sub Location
    async getCaseSubLocation({ commit }, params) {
        return new Promise((resolve, reject) => {
            global.axios.get(`api/case-sub-location`, { params: params })
            .then(response => {
                resolve(response);
            }).catch(error => reject(error));
        });
    },

    async escalation({ commit }, params) {
        return new Promise((resolve, reject) => {
            let formData = new FormData();
            if(params.attachments && params.attachments.length) {
                for( var i = 0; i < params.attachments.length; i++ ){
                    let photo = params.attachments[i];
                    formData.append('files[' + i + ']', photo);
                    formData.append('fileTitles[' + i + ']', photo.image_file_title || '');
                }
            }
            if(params.reply!==null && params.reply==true)
            {
                formData.append("from",params.from);
                formData.append("reply",params.reply);
            }
            

            formData.append("work_item_id", params.work_item_id);
            formData.append("work_item_type", params.work_item_type);
            formData.append("time_stamp", params.time_stamp);
            formData.append("action", params.action || '' );
            formData.append("actor_id", params.actor_id || '' );
            formData.append("actor", params.actor || '' );
            formData.append("remark", params.remark || '');
            formData.append("log_type", params.log_type);

            formData.append("caseId", params.caseId);
            formData.append("nlt_case_key_action", params.nlt_case_key_action || '');
            formData.append("to", params.to || '');
            formData.append("cc", params.cc || '');

            formData.append("subject", params.subject || '');
            formData.append("body", params.body || '');
            formData.append("is_send_email", params.is_send_email || false);
            formData.append("is_change_case_status", params.is_change_case_status || false);
            formData.append("is_create_email", params.is_create_email || false);
            formData.append("is_send_sms", params.is_send_sms || false);
            formData.append("phone_number_sms", params.phone_number_sms || '');
            formData.append("messages_sms", params.messages_sms || '');
            formData.append("nature_feedback", JSON.stringify(params.nature_feedback) || '');
            formData.append("from", params.from || '');
            // formData.append("is_push_noti", params.is_push_noti || false);
            global.axios.post(`api/cases/escalation`, formData)
                .then(response => {
                    resolve(response);
                })
                .catch(error => reject(error));
        });
    },

    async ntlChangeAction({ commit }, params) {
        return new Promise((resolve, reject) => {
            global.axios.post(`api/cases/ntl-change-action`, params)
                .then(response => {
                    resolve(response);
                })
                .catch(error => reject(error));
        });
    },

    async caseKPI({ commit }, params) {
        return new Promise((resolve, reject) => {
            global.axios.get(`api/cases/kpi-target/${params}`)
                .then(response => {
                    resolve(response);
                })
                .catch(error => reject(error));
        });
    },
    async linkCaseSubmit({ commit }, params) {
        return new Promise((resolve, reject) => {
            global.axios.post(`api/cases/link-case`, params)
                .then(response => {
                    resolve(response);
                })
                .catch(error => reject(error));
        });
    },

    async exportCaseNLT({ commit }, params) {
        return new Promise((resolve, reject) => {
            global.axios.get(`api/cases/export-nlt`, {
                    params: params,
                    responseType: 'blob'
                })
                .then(response => {
                    resolve(response);
                })
                .catch(error => reject(error));
        });
    },
};

const mutations = {
    setListItems(state, data) {
        data.pages.totalPage = Math.ceil(data.total / data.pages.limit)
        state.Items.data = data.items
        state.Items.total = data.total
        state.Items.pages = data.pages
    },
    setTotalListItems(state, total) {
        state.Items.total = total
    },
    setSimilarCase(state, data) {
        data.pages.totalPage = Math.ceil(data.total / data.pages.limit)
        state.Items.data = data.items
        state.Items.total = data.total
        state.Items.pages = data.pages
    },
    setLoadings(state, data) {
        state.Loadings[data.key] = data.val;
    },
    setSelectRequestors(state, data) {
        state.Requestors.data = data.items;
        state.Requestors.total = data.total;
    },
    setFaultTypes(state, data) {
        state.FaulTypes.data = data.items;
        state.FaulTypes.total = data.total;
    },
    setItem(state, data) {
        state.Item = data;
    },
    updateRemarkCase(state, data) {
        state.Item = {...state.Item, ...data };
    },
    deleteAttachments(state, data) {
        if (data.action == 'action_taken') {
            state.Item.action_taken.attachments = state.Item.action_taken.attachments.filter(img => !data.ids.includes(img.id))
        }
        if (data.action == 'work_finding') {
            state.Item.work_finding.attachments = state.Item.work_finding.attachments.filter(img => !data.ids.includes(img.id))
        } else {
            state.Item.attachments = state.Item.attachments.filter(img => !data.ids.includes(img.id))
        }
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}